import { GullLayouts } from "./index";
import { useEffect, Suspense, Fragment, useContext } from "react";
import config from "./../../config.json";
import TopLoadingBar from "app/common/ReactAxiosProgressBar";
import { AppContext } from "app/appContext";

const GullLayout = ({ children }) => {
  const { user } = useContext(AppContext);

  const layoutName =
    user.role.toLowerCase() === "master admin" ? "layout2" : "layout1";

  const Layout = GullLayouts[layoutName];

  useEffect(() => {
    setTimeout(() => {
      document.documentElement.setAttribute("dir", "ltr");
    });
  }, []);

  return (
    <Suspense>
      <Fragment>
        <Layout>{children}</Layout>
        <TopLoadingBar />
      </Fragment>
    </Suspense>
  );
};

export default GullLayout;
